<template>
  <div>
    <b-button
      class="myBtn btn-azul-medio border border-light d-xl-none"
      @click="scrollToTop"
      v-if="arriba"
    >
      <FontAwesomeIcon icon="angle-up" class="h5 mb-0" />
    </b-button>
    <section
      id="flecha-abajo"
      class="demo border bg-azul d-md-none"
      @scroll="handleScroll"
      v-if="!mueve"
    >
      <div class="bg-degrade-blanco w-100 fixed-bottom py-5">
        &nbsp;
        <a>
          <span></span>
        </a>
      </div>
    </section>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faAngleUp);
export default {
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      mueve: false,
      arriba: false
    };
  },
  mounted: function() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed: function() {
    this.eliminarListenerFlechaAbajo();
  },
  methods: {
    //mueve pagina a parte superior
    scrollToTop: function() {
      window.scrollTo(0, 0);
    },
    handleScroll(e) {
      this.mueve = true;
      if (
        Math.round(window.pageXOffset) != 0 ||
        Math.round(window.pageYOffset) != 0
      ) {
        this.arriba = true;
      } else {
        this.arriba = false;
      }
    },
    eliminarListenerFlechaAbajo() {
      window.removeEventListener("scroll", this.handleScroll);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generales/FlechaArriba.vue